import React, { useState  } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker  from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';


const AddMenu = () =>{

    const [selectedDate, setSelectedDate] = useState(null);
    const handleDateChange = (date) => {
      setSelectedDate(date); // Update the state with the selected date
    };

    const options_item_cat = [
        { value: "0", label: "Select Item Category" },
        { value: "Breakfast", label: "Breakfast", isFixed: true },
        { value: "Dinner", label: "Dinner" },
        { value: "Meals box", label: "Meals box" },
        { value: "Anjaraipetti", label: "Anjaraipetti" },
    ];

    const options_main_dish = [
        { value: "0", label: "Select Main Dish" },
        { value: "Idly (03)", label: "Idly (03)", isFixed: true },
        { value: "Uthappam (03)", label: "Uthappam (03)" },
        { value: "Milagu Rasam", label: "Milagu Rasam" },
        { value: "Coconut Rice", label: "Coconut Rice" },
    ];

    const options_side_dish = [
        { value: "0", label: "Select Side Dish" },
        { value: "Cauliflower Fry", label: "Cauliflower Fry", isFixed: true },
        { value: "Sambar", label: "Sambar" },
        { value: "Mint Chutney", label: "Mint Chutney" },
        { value: "Potato Masala", label: "Potato Masala" },
    ];
    
        
    const options_prdt = [
        { value: "0", label: "Select Product" },
        { value: "Break Box", label: "Break Box" },
        { value: "Meals Box", label: "Meals Box" },
        { value: "Anjaraipetti", label: "Anjaraipetti" },
        { value: "Dinner Box", label: "Dinner Box" },
    ];
    
    const [selectedOption, setSelectedOption] = useState(null);
    const [setIsFocused] = useState(false);
    
    const handleFocus = () => {
        setIsFocused(true);
    };
    
    const handleBlur = () => {
        setIsFocused(false);
    };
        
    const customStyles = {
        control: (base, state) => ({
            ...base,
            boxShadow: state.isFocused ? `0 0 0 1px #3b5220` : base.boxShadow, 
            borderColor: state.isFocused ? "#3b5220" : '#ffffff', 
            transition: "all 0.3s ease", 
            borderBottom: '1px solid',
            fontSize: '1rem', // Set font size here
            '&:hover': {
            // borderColor: '#3b5220', // Apply border color on hover
            boxShadow: '0 0 0 1px #3b5220', // Apply box-shadow on hover
            }
        }),
        
        // Option styling (hover, selected, and clicked)
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
            ? '#cfe0bd'  // Selected option background color
            : state.isFocused
            ? '#76a54159' // Hovered option background color
            : base.backgroundColor, // Default background color
            color: state.isSelected || state.isFocused ? '#000000' : base.color, // Text color for selected or hovered options
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            '&:active': {
            backgroundColor: '#cfe0bd', // Ensure the background color remains #cfe0bd when option is clicked (active state)
            }
        }),
        
        // For selected value styling in the control box
        singleValue: (base) => ({
            ...base,
            color: '#000000', // Text color for selected value
        }),
        
        // Clear indicator styling (if necessary)
        clearIndicator: (base) => ({
            ...base,
            color: '#000000', // Clear icon color
        }),
        
        // Indicator separator styling
        indicatorSeparator: (base) => ({
            ...base,
            backgroundColor: '#ffffff', // Set the background color of the separator to white
        }),
    };



    return(
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Add Mega Menu</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Menus</li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Manage Menu</li>
                    </ol>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Item Category <span className="required">*</span></label>
                    <Select
                        defaultValue={selectedOption}
                        onChange={setSelectedOption}
                        options={options_item_cat}
                        styles={customStyles}
                    />
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Product <span className="required">*</span></label>
                    <Select
                        defaultValue={selectedOption}
                        onChange={setSelectedOption}
                        options={options_prdt}
                        styles={customStyles}
                    />
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Date <span className="required">*</span></label>
                    <div className='d-block mt-2'>
                        <DatePicker 
                        selected={selectedDate} 
                        onChange={handleDateChange} 
                        className="form-control"
                        dateFormat="dd-MMM-yyyy" 
                        />
                    </div>
                </div>
            </div>
            <div className='row mb-2'>
                <label className="text-black font-w700 fs-5">Main Dish </label>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7" style={{ fontSize: '0.875rem' }}>
                        Main Dish 1<span className="required" style={{ color: 'red' }}>*</span>
                    </label>
                    <Select
                        defaultValue={selectedOption}
                        onChange={setSelectedOption}
                        options={options_main_dish}
                        styles={customStyles}
                    />
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7" style={{ fontSize: '0.875rem' }}>
                        Main Dish 2<span className="required" style={{ color: 'red' }}>*</span>
                    </label>
                    <Select
                        defaultValue={selectedOption}
                        onChange={setSelectedOption}
                        options={options_main_dish}
                        styles={customStyles}
                    />
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7" style={{ fontSize: '0.875rem' }}>
                        Main Dish 3<span className="required" style={{ color: 'red' }}>*</span>
                    </label>
                    <Select
                        defaultValue={selectedOption}
                        onChange={setSelectedOption}
                        options={options_main_dish}
                        styles={customStyles}
                    />
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7" style={{ fontSize: '0.875rem' }}>
                        Main Dish 4<span className="required" style={{ color: 'red' }}>*</span>
                    </label>
                    <Select
                        defaultValue={selectedOption}
                        onChange={setSelectedOption}
                        options={options_main_dish}
                        styles={customStyles}
                    />
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7" style={{ fontSize: '0.875rem' }}>
                        Main Dish 5<span className="required" style={{ color: 'red' }}>*</span>
                    </label>
                    <Select
                        defaultValue={selectedOption}
                        onChange={setSelectedOption}
                        options={options_main_dish}
                        styles={customStyles}
                    />
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7" style={{ fontSize: '0.875rem' }}>
                        Main Dish 6<span className="required" style={{ color: 'red' }}>*</span>
                    </label>
                    <Select
                        defaultValue={selectedOption}
                        onChange={setSelectedOption}
                        options={options_main_dish}
                        styles={customStyles}
                    />
                </div>
            </div>
            <div className='row mb-2'>
                <label className="text-black font-w700 fs-5">Side Dish </label>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Side Dish 1<span className="required">*</span></label>
                    <Select
                        defaultValue={selectedOption}
                        onChange={setSelectedOption}
                        options={options_side_dish}
                        styles={customStyles}
                    />
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Side Dish 2<span className="required">*</span></label>
                    <Select
                        defaultValue={selectedOption}
                        onChange={setSelectedOption}
                        options={options_side_dish}
                        styles={customStyles}
                    />
                </div>
                <div className="col-lg-12 mb-4">
                    <label className="text-black font-w500 fs-7">Description<span className="required">*</span></label>
                    <textarea rows={8} className="form-control" name="comment" placeholder="Description" defaultValue={"-"}/>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                <Link to={'/manage-menus'} type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                <Link to={'/manage-menus'} type="submit" className="btn btn-sm btn-primary">Create Mega Menu</Link>
            </div>
        </>
    )

    
}
export default AddMenu;